module.exports = __webpack_public_path__ + "static/media/ssv-mocks.fd260fe6.png";